// EditModal.jsx
import React from 'react';
import { Modal, Form, Input } from 'antd';

const AlterParceiro = ({ visible, onOk, onCancel, form }) => (
  <Modal
    title="Editar Cliente"
    visible={visible}
    onOk={onOk}
    onCancel={onCancel}
    okText="Salvar"
    cancelText="Cancelar"
  >
    <Form form={form} layout="vertical">
      <Form.Item
        name="nome"
        label="Nome"
        rules={[{ required: true, message: 'Por favor, insira o nome' }]}
      >
        <Input placeholder="Nome" />
      </Form.Item>
      <Form.Item
        name="email"
        label="E-mail"
        rules={[{ required: true, message: 'Por favor, insira o e-mail' }]}
      >
        <Input placeholder="E-mail" />
      </Form.Item>
      <div style={{ display: 'flex', gap: '16px' }}>
        <Form.Item
          name="user"
          label="Usuário"
          rules={[{ required: true, message: 'Por favor, insira o usuário' }]}
          style={{ flex: 1 }}
        >
          <Input placeholder="Usuário" />
        </Form.Item>
        <Form.Item
          name="senha"
          label="Senha"
          rules={[{ required: true, message: 'Por favor, insira a senha' }]}
          style={{ flex: 1 }}
        >
          <Input.Password placeholder="Senha" />
        </Form.Item>
      </div>
    </Form>
  </Modal>
);

export default AlterParceiro;
